import React from 'react';
import { Paper, Typography, Grid, Tooltip, IconButton, Divider, useTheme } from '@mui/material';
import { SHAPE_CATEGORIES } from '../constants/shapes';

const ShapesPanel = ({ onAddShape }) => {
  const theme = useTheme();
  return (
    <Paper sx={{ width: '100%', flex: 1, minHeight: 0, overflowY: 'auto', bgcolor: theme.palette.background.paper, borderRadius: 0, borderRight: `1px solid ${theme.palette.divider}`, p: 1, mt: 1 }}>
      <Typography variant="subtitle2" sx={{ color: theme.palette.text.primary, mb: 1 }}>Shapes</Typography>
      {SHAPE_CATEGORIES.map((cat, idx) => (
        <div key={cat.id}>
          {idx > 0 && <Divider sx={{ my: 1, borderColor: theme.palette.divider }} />}
          <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5 }}>{cat.name}</Typography>
          <Grid container spacing={1}>
            {cat.items.map((shape) => (
              <Grid item xs={6} key={shape.id}>
                <Tooltip title={shape.name}>
                  <IconButton
                    onClick={() => onAddShape?.(shape)}
                    sx={{ width: '100%', aspectRatio: '1 / 1', bgcolor: theme.palette.action.hover, border: `1px solid ${theme.palette.divider}`, '&:hover': { bgcolor: theme.palette.action.selected } }}
                  >
                    <span
                      style={{
                        display: 'inline-block',
                        width: '70%',
                        height: '70%',
                        // Fixed preview colors so Properties panel changes don't affect the palette
                        color: theme.palette.text.disabled,
                        fill: theme.palette.text.secondary,
                      }}
                      dangerouslySetInnerHTML={{ __html: shape.svg }}
                    />
                  </IconButton>
                </Tooltip>
              </Grid>
            ))}
          </Grid>
        </div>
      ))}
    </Paper>
  );
};

export default ShapesPanel;
